// PaymentConfirmedBanner — full-width success notice shown when a payment is verified while the
// student watches the Payments page. Dismissed by ×, by "View courses", or by the caller's timer.
import ViewCoursesLink from "./ViewCoursesLink.js";
import type { PaymentWithCourse } from "@dm-lms/shared/types";

interface PaymentConfirmedBannerProps {
  payment:   Pick<PaymentWithCourse, "code" | "courseTitle">;
  onDismiss: () => void;
}

export default function PaymentConfirmedBanner({ payment, onDismiss }: PaymentConfirmedBannerProps) {
  return (
    <div role="status" className="relative mb-4 rounded-lg border border-green-200 bg-green-50 p-4 pr-10 text-sm text-green-800">
      <p className="font-semibold">✓ Payment confirmed!</p>
      <p className="mt-1">
        Your payment {payment.code}
        {payment.courseTitle ? ` for ${payment.courseTitle}` : ""} has been verified. Our team will be in touch with
        next steps.
      </p>
      <div className="mt-3">
        <ViewCoursesLink onClick={onDismiss} />
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={onDismiss}
        className="absolute right-2 top-2 rounded px-2 text-lg leading-none text-green-700 transition hover:bg-green-100"
      >
        ×
      </button>
    </div>
  );
}
